import { Component, OnInit, OnDestroy } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { ModalController } from 'ionic-angular';
import { AlertService } from '../../../providers/alert-service';
import { ArquivosService } from '../../../providers/arquivos-service';
import { ModalArquivosPage } from '../../modais/modal-arquivos/modal-arquivos';
import { UsuarioService } from '../../../providers/usuario-service';
import { GestaoPcaService } from '../../../providers/gestao-pca-service';
import { ModulosController } from '../modulos-controller';
import { MenuService } from '../../../providers/menu-service';
import { ModalEditarTextoPage } from '../../modais/modal-editar-texto/modal-editar-texto';
import { AGORA } from "../../../app/AGORA";
import { map } from 'rxjs/operators/map';
import { environment } from '../../../environments/environment';
import { OpcoesAssinatura } from '../../../assinatura/opcoes-assinatura.model';

declare var dtjava: any;

@Component({
  selector: 'page-arquivos',
  templateUrl: 'arquivos.html',
  providers: [
    ArquivosService,
    AGORA
  ]
})
export class ArquivosPage extends ModulosController implements OnInit, OnDestroy {
  codigoModuloPCA: any = null;
  tipoAnalise: any = null;
  listarPecasProcessuaisObrigatoria: any[];
  listarPecasProcessuaisNObrigatoria: any[];
  usuario: any;
  analise: any;
  abaObrigatorio: any;
  teste: any;
  idModuloPCA: any;
  idProcesso: any;
  tipoArquivo: any;
  cdModulo: any;
  listaJustificativa: any = [];
  PCAAtiva: any;
  isSefaz: boolean;

  resultadoAssinatura: Boolean = false;
  idModuloAnalise: any;

  order: string = 'nmTipoDocumento';
  reverse: boolean = false;

  orderMod: string = 'dsModulo';
  reverseMod: boolean = false;

  usuarioLogado: any;
  loadingObrigatoria: boolean = true;
  loadingComplementar: boolean = true;

  static isAlertaAberto: boolean = false;

  opcoes: OpcoesAssinatura;
  showAssinatura:  boolean = true;

  constructor(public AGORA: AGORA,
    public navCtrl: NavController,
    public navParams: NavParams,
    public arquivosService: ArquivosService,
    public gestaoPcaService: GestaoPcaService,
    public modalCtrl: ModalController,
    private menuService: MenuService,
    public usuarioService: UsuarioService,
    public alertService: AlertService) {

    super(modalCtrl, navParams, alertService, usuarioService, gestaoPcaService);
    this.analise = this.navParams.get('analise');

    if (!this.analise) {
      this.analise = this.navParams.get('data').analise;
    }

    this.usuarioLogado = this.usuarioService.obtemUsuario();

    this.PCAAtiva = this.gestaoPcaService.getPCA();
    // console.log("PCA ATIVA: ");
    // console.log(this.PCAAtiva);

    this.isSefaz = this.PCAAtiva.dsJurisdicionado == "SECRETARIA DA FAZENDA DO ESTADO DO CEARÁ";

    this.abaObrigatorio = 'obrigatorio';

    // entra neste if quando a origem é qualquer modulo do sistema.
    if (this.navParams.get('analise') != undefined) {

      this.idModuloPCA = this.navParams.get('analise').idModuloPca;
      this.idModuloAnalise = this.navParams.get('analise').idModuloAnalise;

      if (this.navParams.get('analise').idProcesso != undefined) {
        this.idProcesso = this.navParams.get('analise').idProcesso;// Codigo do ID Processo enviado dos módulos
        this.tipoAnalise = this.navParams.get('analise').cdAnalise;
        this.cdModulo = this.navParams.get('analise').cdModulo;
      }
      else {
        this.idProcesso = 0;
        this.tipoAnalise = 0
      }

    } else {
      this.idModuloAnalise = -1;
      this.idModuloPCA = -1;
      this.idProcesso = 0;
      this.tipoAnalise = 0;
    }

    // this.usuario = usuarioService.obtemUsuario();
    // if (this.usuario != undefined) {
    //   this.isJurisdicionado = this.usuarioService.isJurisdicionado();
    // }

    this.carregarPagina();

    this.setModuloId(15);

    this.inicarOpcoesAssinatura();
  }

  ngOnInit() {
    if (!ArquivosPage.isAlertaAberto && this.isJurisdicionado) {
      this.alertService.mostraAlerta('Observações', '- Em todas as peças marcadas com as extensões "PDF; XML", é necessário adicionar os dois tipos de arquivo. Ambos podem ser retirados do sistema SIAFE.');
      ArquivosPage.isAlertaAberto = true;
    }
  }

  ngOnDestroy() {
    ArquivosPage.isAlertaAberto = false;
  }

  carregarPagina() {
    //chama em segundo as peças não obrigatórias, parametro 0 de false
    this.arquivosService.listarPecasProcessuaisNObrigatoria(this.idModuloPCA).subscribe(data => {
      this.listarPecasProcessuaisNObrigatoria = data;
      this.loadingComplementar = false;
    }, error => {
      console.log("erro: " + error);
      this.loadingComplementar = false;
    });

    let contadorPeca = 0;

    this.arquivosService.listarPecasProcessuaisObrigatoria(this.idModuloPCA).subscribe(data => {
      
      this.listarPecasProcessuaisObrigatoria = data;

      /*this.listarPecasProcessuaisObrigatoria.forEach(arquivo => {
        console.log(arquivo);
        console.log(`${arquivo} ${arquivo.dsModulo} ${arquivo.flNaoSeAplica}`);
      });*/
      // this.listarPecasProcessuaisObrigatoria.forEach(item => {
      //   this.arquivosService.obterJustificativa(item.idModuloPca, item.moduloPecaSap.idModuloPecaSap).subscribe(just => {

      //     if (just.length != 0) {
      //       if (just[0].justificativa) {
      //         item.possuiJustificativa = 'true';
      //       } else {
      //         item.possuiJustificativa = 'false';
      //       }
      //     } else {
      //       item.possuiJustificativa = 'false';
      //     }

      //   }, error => {
      //     console.log("erro: " + error);
      //     this.loadingObrigatoria = false;
      // });

      // });

      this.loadingObrigatoria = false;
    }, error => {
      console.log("erro: " + error);
      this.loadingObrigatoria = false;
    });

    // setTimeout(() => {
    //   this.loading = false;
    // }, 20000);

  }

  log(val) {
    console.log(val);
  }

  abrirListarArquivo(pidModuloPCA, idProcessoJustificativa, ptipoEntidadeExercicio, pTipodocumento, pModulo, pFlSefaz) {

    this.showAssinatura = false;
    let titulo = "Peças Processuais";
    let validaCGE = false;

    if (this.isCGE) {
      if (pModulo == 'Controle Interno') {
        validaCGE = false;
      } else {
        validaCGE = this.isCGE;
      }
    } else {
      validaCGE = this.isCGE;
    }

    // console.log("FLSefaz - botao:" + pFlSefaz);

    let modal = this.modalCtrl.create(ModalArquivosPage,
      {
        titulo: titulo,
        IdProcesso: this.idProcesso,
        idProcessoJustificativa: idProcessoJustificativa,
        idModuloPCA: pidModuloPCA,
        tipoAnalise: this.tipoAnalise,
        jurisdicionado: this.isJurisdicionado,
        isCGE: validaCGE,
        pFlSefaz: pFlSefaz,
        tipoEntidadeExercicio: ptipoEntidadeExercicio,
        tipodocumento: pTipodocumento,
        listaTipoDocumentos: [
          pTipodocumento
        ],
        isModuloPeca: true,
        analise: this.analise
      });
    modal.onDidDismiss(retornoModal => {
      this.carregarPagina();
      this.showAssinatura = true;
    });

    modal.present();
  }

  voltar() {

    this.cdModulo = String(this.navParams.get('analise').cdModulo)

    this.menuService.redirecionarPagina(this.cdModulo);
  }

  voltarPCA() {
    let idSecaoPaginaGestaoPCA = '964';

    this.menuService.redirecionarPagina(idSecaoPaginaGestaoPCA);
  }

  adicionarJustificativa(item) {

    this.arquivosService.obterJustificativa(item.idModuloPca, item.moduloPecaSap.idModuloPecaSap).subscribe(justific => {

      let id = 0;
      let texto = "";

      if (justific.length != 0) {
        id = justific[0].id;
        texto = justific[0].justificativa;
      }

      this.listaJustificativa.pop(justific);

      let just = {
        "id": id,
        "justificativa": texto,
        "moduloPecaSap": {
          "idModuloPecaSap": item.moduloPecaSap.idModuloPecaSap,
          "modulo": {
            "idModulo": item.moduloPecaSap.modulo.idModulo,
            "codModulo": item.moduloPecaSap.modulo.codModulo,
            "dsModulo": item.moduloPecaSap.modulo.dsModulo
          },
          "idTipoDocumentoSap": item.moduloPecaSap.idTipoDocumentoSap,
          "qtdArquivos": item.moduloPecaSap.qtdArquivos,
          "tipoArquivos": item.moduloPecaSap.tipoArquivos
        },
        "idModuloPca": item.idModuloPca
      }

      let modal = this.modalCtrl.create(ModalEditarTextoPage, { texto: just.justificativa, isCGE: this.isCGE, isJurisdicionado: this.isJurisdicionado, parecer: this.isJurisdicionado, analise: this.analise });
      modal.onDidDismiss(retornoModal => {
        if (retornoModal != undefined && retornoModal.salvar) {
          just.justificativa = retornoModal.texto;

          this.listaJustificativa.push(just);

          this.arquivosService.salvarJustificativa(this.listaJustificativa).subscribe(data => {
            //this.carregarPagina();

            this.loadingComplementar = true;
            this.loadingObrigatoria = true;

            if (just.justificativa && just.justificativa != '') {
              item.possuiJustificativa = 'true';
            } else {
              item.possuiJustificativa = 'false';
            }

            this.alertService.mostraAlerta("", "Justificativa salva com sucesso.");

            this.carregarPagina();

          }, error => {
            this.alertService.mostraAlerta("", "Ocorreu um erro ao salvar a justificativa:" + error);
          });
        }
      });
      modal.present();

    }, error => console.log("erro: " + error));

    this.carregarPagina();
  }

  truncateText(text) {
    let numberOfWordsToTruncate = 10;

    if (text != undefined) {
      let separatedByWords = text.toString().split(" ");

      if (this.needTruncate(text)) {
        return separatedByWords.slice(0, numberOfWordsToTruncate).join(" ") + " ...";
      }
      else {
        return text;
      }
    }
  }

  needTruncate(text) {
    let separatedByWords = text.toString().split(" ");
    let numberOfWordsToTruncate = 10;

    return separatedByWords.length >= numberOfWordsToTruncate;
  }

  exibirCompleto(text) {
    this.alertService.mostraAlerta('', text);
  }

  formatarCpf(valor) {
    return valor.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "\$1.\$2.\$3\-\$4");
  }

  assinarTodasAsPecas(item) {

    const cpf = environment.production ? this.usuarioLogado.dadosUsuario[0].cpf : environment.cpfAssinateTeste;

    // Assinar arquivo
    let assinar = this.AGORA.assinarArquivosPecas(this.gestaoPcaService.getPCA().id, item.idModuloPca, item.codModulo,
      item.exercicio, item.idEntidade, item.idTipoEntidadeExercicio, item.idTipoDocumento, cpf, this.usuarioService.obterDadosUsuario().perfil);
    assinar.subscribe(
      next => {
        console.log('Sucesso: %s', next);
      },
      error => {
        console.log('Erro: %s', error);
        this.alertService.mostraAlerta("Erro encontrado", error);
      });

  }

  buscarInconsistencias(): any[] {
    let msgInconsistencias = [];
    this.listarPecasProcessuaisObrigatoria.forEach(peca => {
      this.arquivosService.obterJustificativa(peca.idModuloPca, peca.moduloPecaSap.idModuloPecaSap).pipe(map(justific => {

        let texto = "";

        if (justific.length != 0) {
          texto = justific[0].justificativa;
        }

        if (!peca.flPossuiArquivo) {
          if (justific.length == 0 || texto == "") {
            msgInconsistencias.push(peca.nmTipoDocumento);
          }
        }
      }));
    });

    return msgInconsistencias;
  }

  salvar() {
    if (this.idModuloAnalise == undefined) {
      this.idModuloAnalise = 0;
    }

    this.arquivosService.salvarModuloPecasProcessuais(this.listarPecasProcessuaisNObrigatoria, this.idModuloPCA, this.idModuloAnalise).subscribe(data => {
      this.alertService.mostraAlerta("", "Peças salvas com sucesso.");
    }, error => {
      this.alertService.mostraAlerta("", "Ocorreu um erro ao salvar as peças:" + error.mensagem);
    });
  }

  finalizar() {

    let msgInconsistencias = "";
    let constReticenciasMaisPularLinhaHTML = "... <br><br>";

    this.buscarInconsistencias().forEach(iconsistencia => {
      msgInconsistencias += iconsistencia.substring(0, 35) + constReticenciasMaisPularLinhaHTML;
    });

    if (msgInconsistencias != "") {
      this.alertService.mostraAlerta("A ausência das Peças abaixo não foram devidamente justificadas:", msgInconsistencias);
    } else {

      if (this.idModuloAnalise == undefined) {
        this.idModuloAnalise = 0;
      }

      this.arquivosService.finalizarModuloPecasProcessuais(this.listarPecasProcessuaisNObrigatoria, this.idModuloPCA, this.idModuloAnalise).subscribe(data => {
        this.alertService.mostraAlerta("", "Análise finalizada com sucesso.");

        if (this.idModuloPCA != -1) {
          this.voltar();
        } else {
          this.voltarPCA();
        }
      }, error => {
        this.alertService.mostraAlerta("", "Ocorreu um erro ao finalizar a analise:" + error.mensagem);
      });
    }
  }

  modalEvidencias(item: any) {

    this.showAssinatura = false;

    let titulo = "Evidências";
    // console.log(item);
    let modal = this.modalCtrl.create(ModalArquivosPage,
      {
        titulo: titulo,
        IdProcesso: item.moduloPecaSap.idModuloPecaSap,
        idModuloPCA: item.idModuloPca,
        tipoAnalise: 0,
        jurisdicionado: this.isJurisdicionado,
        isCGE: this.isCGE,
        tipoEntidadeExercicio: item.idTipoEntidadeExercicio,
        tipodocumento: item.idTipoDocumento,
        analise: this.analise
      });

    modal.onDidDismiss(retornoModal => {
      this.showAssinatura = true;
      this.carregarPagina();
    });

    modal.present();

  }

  //Nova Versão Assinatura
  inicarOpcoesAssinatura() {

    const cpf = environment.production ? this.usuarioLogado.dadosUsuario[0].cpf : environment.cpfAssinateTeste;

    this.opcoes = {
      arquivos: [],
      cpfUsuarioLogado: cpf,
      urlBackEndCallBack: environment.urlBackEndCallBackAssinatura,
      dadosBackEndCallBack: [],
      idPca: this.PCAAtiva.id,
      tipoArquivo: 'TIPO_VINCULADO'
    };
  }

  marcarArquivoParaAssinar(evento: any, arquivo: any) {

    // console.log(arquivo)

    if (!arquivo.arquivosVinculados || arquivo.arquivosVinculados.length == 0) {
      evento.checked = false;
      return;
    }

    if (evento.checked) {
      arquivo.arquivosVinculados.forEach(element => {
        /* if (!element.assinado) { */
          this.incluirArquivoNasOpcoesAssinatura(element.pathArquivo);
          this.incluirArquivoNosDadosDoCallBackAssinatura(element);
        /* } */
      });
    } else {
      arquivo.arquivosVinculados.forEach(element => {
        /* if (!element.assinado) { */
          this.removerArquivoDasOpcoesAssinatura(element.pathArquivo);
          this.removerArquivoDosDadosDoCallBackAssinatura(element);
        /* } */
      });
    }

    let quantidade = this.opcoes.arquivos.length
    this.alertService.mostrarToast(`${quantidade} ${quantidade > 0 ? 'arquivos selecionados' : ' arquivo selecionados'}`);
    // console.log(this.opcoes.dadosBackEndCallBack);
  }

  private incluirArquivoNasOpcoesAssinatura(caminho: string) {
    this.opcoes.arquivos.push(caminho);
  }
  private removerArquivoDasOpcoesAssinatura(caminho: string) {
    this.opcoes.arquivos = this.opcoes.arquivos.filter(c => {
      return caminho !== c;
    });
  }

  private incluirArquivoNosDadosDoCallBackAssinatura(arquivo: any) {
    this.opcoes.dadosBackEndCallBack.push({
      idPca: this.PCAAtiva.id,
      idDocumento: arquivo.idArquivoVinculado,
      cpfAssinante: this.formatarCpf(this.usuarioLogado.dadosUsuario[0].cpf),
      perfil: this.usuarioService.obterDadosUsuario().perfil
    });
  }
  private removerArquivoDosDadosDoCallBackAssinatura(arquivo: any) {
    this.opcoes.dadosBackEndCallBack = this.opcoes.dadosBackEndCallBack.filter(a => {
      return a.idDocumento !== arquivo.idArquivoVinculado;
    });
  }

  sucesso(evento: any) {
    this.carregarPagina();
    this.inicarOpcoesAssinatura();
    // console.log('Assinatura realizada com sucesso.');
  }

  isAbilitarBotaoAssinatura() {
    return this.opcoes.arquivos.length > 0;
  }

  /*assinarDocumento(documento: any) {
    console.log('doc', documento);
    const cpf = environment.production ? this.usuarioLogado.dadosUsuario[0].cpf : environment.cpfAssinateTeste;
  
    const opcoes = {
      arquivos: [],
      cpfUsuarioLogado: cpf,
      urlBackEndCallBack: environment.urlBackEndCallBackAssinatura,
      dadosBackEndCallBack: [{
        idPca: null,
        idDocumento: null,
        cpfAssinante: this.formatarCpf(this.usuarioLogado.dadosUsuario[0].cpf),
        perfil: this.usuarioService.obterDadosUsuario().perfil
      }],
      idPca: null,
      tipoArquivo: 'TIPO_SUBMISSAO_PCA'
    };

    this.assinaturaService.iniciarAssinaturaObservable(opcoes).subscribe( result => {
      console.log('Assinatura realizada com sucesso');
    });
  }*/

}



// WEBPACK FOOTER //
// ./src/pages/modulos/arquivos/arquivos.ts